import { StyleSheet } from 'react-native';

import { lightGrey } from 'utils/colors.ts';
import { widthPercentageToDP } from 'utils/responsiveness';

const CLOSE_BUTTON_ICON_SIZE = 16;
const EXIT_FULLSCREEN_BUTTON_ICON_SIZE = 24;
const BUTTON_SIZE = 40;

const styles = StyleSheet.create({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        flexDirection: 'row',
    },
    info: {
        flex: 1,
    },
    row: {
        flexDirection: 'row',
    },
    topButtonsRow: {
        flexDirection: 'row',
        alignSelf: 'flex-start',
        right: (CLOSE_BUTTON_ICON_SIZE - BUTTON_SIZE) / 2,
    },
    topTabletEmbeddedButtonsRow: {
        flexDirection: 'row',
        alignSelf: 'flex-start',
        marginRight: 28,
    },
    topTabletEmbeddedButton: {
        marginRight: 26,
        width: 24,
    },
    topTabletEmbeddedButtonSvg: {
        width: 24,
        height: 24,
    },
    topButton: {
        width: 40,
    },
    topButtonSvg: {
        width: 24,
        height: 24,
    },
    topButtonAudioSubtitles: {
        width: 40,
    },
    topButtonAudioSubtitlesSvg: {
        width: 24,
        height: 24,
    },
    closeButton: {
        right: (CLOSE_BUTTON_ICON_SIZE - BUTTON_SIZE) / 2,
        width: 40,
        height: 40,
    },
    closeSvg: {
        width: 16,
        height: 16,
    },
    exitFullscreenSvg: {
        width: 24,
        height: 24,
    },
    exitFullscreenButton: {
        right: (EXIT_FULLSCREEN_BUTTON_ICON_SIZE - BUTTON_SIZE) / 2,
        width: 40,
        height: 40,
    },
    topButtonsRowEmbeddedWeb: {
        marginRight: -widthPercentageToDP(20),
    },
    castButton: {
        width: 24,
        height: 24,
        marginRight: 8,
        top: 8,
    },
    heartIcon: { width: 24, height: 24 },
});

export default styles;
